module.exports = __webpack_public_path__ + "static/maruya-e4d661aa2205142b5b508cd912db7f70.jpg";